import { useCreateAdminAxiosInstance } from "./useCreateAdminAxiosInstance.ts";

export function useCreateStripeAdminAxiosInstance() {
  return useCreateAdminAxiosInstance(
    import.meta.env.VITE_STRIPE_ADAPTER_BASE_URL,
  );
}
